<template>
  <div class="freestyle-container">
    <AudioControl />
    <div
      class="freestyle-container--border"
    >
      <div
        v-if="$store.state.slide.backgroundImage"
        class="freestyle-container--background-wrapper"
        :style="{
          'background-image': 'url(' + $store.state.slide.backgroundImage.large + ')' ,
          'background-size': 'cover',
          opacity: $store.state.slide.visibility / 100
        }"
      />
      <div
        v-if="$store.state.slide.image"
        class="freestyle-container--background-wrapper"
        :style="{
          'background-image': 'url(' + $store.state.slide.image.large + ')' ,
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center'

        }"
      />
      <div class="freestyle-container--thumbnail-wrapper">
        <FreestyleThumbnailPreview :slide="slideActive" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import FreestyleThumbnailPreview from './freestyle/FreestyleThumbnailPreview.vue'
import EventBus from '../../eventBus'
import AudioControl from '../AudioControl.vue'

export default {
  components: {
    FreestyleThumbnailPreview,
    AudioControl,
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slide,
    }),
  },
  watch: {
    slideActive(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.loadCanvasBlocks({
          slideId: newVal.id,
          canvasBlocksUrl: newVal.canvasBlocksUrl,
        })
      }
    },
  },
  async mounted() {
    this.loadCanvasBlocks({
      slideId: this.slideActive.id,
      canvasBlocksUrl: this.slideActive.canvasBlocksUrl,
    })
    EventBus.$on('update-canvas-blocks', (data) => {
      this.loadCanvasBlocks(data)
    })
  },
  destroyed() {
    EventBus.$off('update-canvas-blocks')
  },
  methods: {
    async loadCanvasBlocks(data) {
      if (data.slideId !== this.slideActive.id) return

      let canvasBlocks = {}
      if (data.canvasBlocksUrl) {
        const res = await this.$http.get(`${data.canvasBlocksUrl}&t=${Date.now()}`)
        if (res.body) {
          canvasBlocks = res.body
        }
      }

      this.$store.dispatch('updateSlide', {
        canvasBlocks,
        canvasBlocksUrl: data.canvasBlocksUrl,
      })
    },
  },

}
</script>

<style lang="scss" scoped>
  .freestyle-container {
    padding: 0 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
.freestyle-container--border {
  margin-top: 20px;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 4px;
  border: 1px solid #ccc;
  overflow: hidden;
  position: relative;
}

.freestyle-container--background-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

.freestyle-container--thumbnail-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 8%;
  left: 4px;
  z-index: 4;
}

</style>
